import {useIsFeatureActive} from '@aboutyou/feature-flags';

export const useIsWebCouponsEnabled = () => {
  return useIsFeatureActive('web_coupon').isActive;
};
